import moment from 'moment';

const UNCONFIRMED_BOOKINGS_PAGE_FILTERS = [
    {
        key: 'bookingId',
        label: 'Reservation ID',
        type: 'text'
    },
    {
        key: 'vendor',
        label: 'Vendor name',
        type: 'vendorautocomplete'
    },
    {
        key: 'agent',
        label: 'Agent name',
        type: 'agentautocomplete'
    },
    {
        key: 'guest',
        label: 'Guest name',
        type: 'guestautocomplete'
    },
    {
        key: 'activity',
        label: 'Activity name',
        type: 'activityautocomplete'
    },
    {
        key: 'checkInDate',
        rangeKeys: ['checkInDate', 'checkOutDate'],
        label: 'Activity date',
        type: 'daterange'
    }
];

function getFilterFromUrl(urlSearchPart) {
    const searchParams = new URLSearchParams(urlSearchPart?.trim() !== '' ? urlSearchPart : '');

    const checkInDate =
        searchParams.get('datefrom') !== null && moment(searchParams.get('datefrom')).isValid()
            ? moment(searchParams.get('datefrom'))
            : null;

    const checkOutDate =
        searchParams.get('dateto') !== null && moment(searchParams.get('dateto')).isValid()
            ? moment(searchParams.get('dateto'))
            : null;

    return {
        bookingId: !Number.isNaN(parseInt(searchParams.get('bookingId'), 10))
            ? parseInt(searchParams.get('bookingId'), 10)
            : '',
        vendor: searchParams.get('vendor') || null,
        agent: searchParams.get('agent') || null,
        guest: searchParams.get('guest') || null,
        activity: searchParams.get('activity') || null,
        checkInDate,
        checkOutDate
    };
}

function getUrlFromFilter(filter) {
    const search = new URLSearchParams();

    if (filter.bookingId) {
        search.append('bookingId', filter.bookingId);
    }

    if (filter.vendor) {
        search.append('vendor', filter.vendor);
    }

    if (filter.agent) {
        search.append('agent', filter.agent);
    }

    if (filter.guest) {
        search.append('guest', filter.guest);
    }

    if (filter.activity) {
        search.append('activity', filter.activity);
    }

    if (filter.checkInDate) {
        search.append('datefrom', filter.checkInDate.format('YYYY-MM-DD'));
    }

    if (filter.checkOutDate) {
        search.append('dateto', filter.checkOutDate.format('YYYY-MM-DD'));
    }

    const searchString = search.toString();
    return `?${searchString}`;
}

export { UNCONFIRMED_BOOKINGS_PAGE_FILTERS, getFilterFromUrl, getUrlFromFilter };
